module.exports = __webpack_public_path__ + "static/media/financial_bg.466e0f00.png";